// extracted by extract-css-chunks-webpack-plugin
module.exports = {"CustomConfetti":"w_eid6tf"};